import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { NotificationService } from 'src/app/services/notification.service';
import { Pc003Service } from 'src/app/views/adm/service/pc003.service';

@Component({
  selector: 'app-import-pc003-modal',
  templateUrl: './import-pc003.component.html',
  styleUrls: ['./import-pc003.component.scss']
})
export class ImportPc003ModalComponent {
  fileName: string = '';
  file: File | null = null;

  constructor(public dialogRef: MatDialogRef<ImportPc003ModalComponent>, public service: Pc003Service, protected notificationService: NotificationService) {}

   onFileChange(event: any): void {
     const file = event.target.files[0];
     if (file && file.name.endsWith('.csv')) {
       this.file = file;
       this.fileName = file.name;
     } else {
         this.notificationService.sendNotification("Apenas arquivos CSV são aceitos", TypeMessage.Personalized, ActionMessage.Error)
     }
   }
 
   uploadFile(): void {
     if(!this.fileName.endsWith('.csv')){
         this.notificationService.sendNotification("Apenas arquivos CSV são aceitos", TypeMessage.Personalized, ActionMessage.Error)
     }else{
         let formData:FormData = new FormData();
         formData.append('file', this.file)
         
         this.service.importFile(formData).then(res =>{
           this.dialogRef.close();
         });
     }
  }
}
